import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Spinner, Alert, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { recipesAPI } from '../utils/api';

const RecipeList = () => {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const fetchRecipes = async () => {
    try {
      setLoading(true);
      const res = await recipesAPI.getAll();
      setRecipes(res.data.data || []);
    } catch (err) {
      setError('เกิดข้อผิดพลาดในการดึงข้อมูลสูตร');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecipes();
  }, []);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(amount || 0);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString('th-TH', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });

  return (
    <Container fluid className="main-content">
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2>
                <i className="bi bi-journal-text me-2"></i>
                ประวัติสูตรต้นทุน
              </h2>
              <p className="text-muted">รายการสูตรที่คำนวณต้นทุนไว้</p>
            </div>
            <Button variant="primary" onClick={() => navigate('/recipes/new')}>
              <i className="bi bi-journal-plus me-2"></i>
              คำนวณสูตรใหม่
            </Button>
          </div>
        </Col>
      </Row>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Row>
        <Col>
          <Card>
            <Card.Body>
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 text-muted">กำลังโหลด...</p>
                </div>
              ) : recipes.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="bi bi-journal-x" style={{ fontSize: '3rem' }}></i>
                  <p className="mt-3">ยังไม่มีสูตรที่บันทึกไว้</p>
                  <Button variant="primary" onClick={() => navigate('/recipes/new')}>
                    <i className="bi bi-journal-plus me-2"></i>
                    เริ่มคำนวณสูตรแรก
                  </Button>
                </div>
              ) : (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>ชื่อสูตร</th>
                      <th className="text-center">จำนวนวัตถุดิบ</th>
                      <th className="text-end">ต้นทุนรวม</th>
                      <th>สร้างโดย</th>
                      <th>วันที่สร้าง</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {recipes.map((recipe, idx) => (
                      <tr key={recipe.id}>
                        <td className="text-muted">{idx + 1}</td>
                        <td>
                          <strong>{recipe.name}</strong>
                          {recipe.description && (
                            <div className="text-muted small">{recipe.description}</div>
                          )}
                        </td>
                        <td className="text-center">
                          <Badge bg="secondary">{recipe.items?.length || 0} รายการ</Badge>
                        </td>
                        <td className="text-end fw-bold text-success">
                          {formatCurrency(recipe.totalCost)}
                        </td>
                        <td>{recipe.createdBy?.fullName || recipe.createdBy?.username || '-'}</td>
                        <td className="text-muted small">{formatDate(recipe.createdAt)}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => navigate(`/recipes/${recipe.id}`)}
                          >
                            <i className="bi bi-eye me-1"></i>
                            ดูรายละเอียด
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RecipeList;
